import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { checkBoxCell, customCell, GridPanel, IRoutedTabProps } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../services/api/endpoint";
import { hasPermission } from "../../../services/authentication";
import { Permission } from "../../../utils/enums";
import ExpertiseEditor from "../../editors/personInfo/expertise";

const Expertises: React.FC<IRoutedTabProps> = () => {
	const { t } = useTranslation();

	return (
		<GridPanel
			listEndpoint={Endpoint.ExpertisesList}
			endpoint={Endpoint.Expertises}
			addScreen={{ screen: ExpertiseEditor, isAllowed: hasPermission(Permission.ExpertisesAdd) }}
			editScreen={{ screen: ExpertiseEditor, isAllowed: hasPermission(Permission.ExpertisesUpdate) }}
			delete={{ isAllowed: hasPermission(Permission.ExpertisesDelete) }}
			filter={{
				logic: "and",
				filters: [
					{
						field: "active",
						operator: "eq",
						value: true
					}
				]
			}}
		>
			<GridColumn field="name" title={t("name")} />
			<GridColumn field="active" title={t("active")} filter="boolean" width="160px" cell={customCell(checkBoxCell())} />
		</GridPanel>
	);
};

export default Expertises;
